import React from 'react';

const AdminDashboard = () => {
  return <div>Dashboard</div>;
};

export default AdminDashboard;
